import { HTMLAttributes } from 'react';

interface FloatingActionButtonProps extends HTMLAttributes<HTMLButtonElement> {
  onClick: () => void;
  isOpen?: boolean;
}

export default function FloatingActionButton({ 
  onClick, 
  isOpen = false,
  className = '',
  ...props 
}: FloatingActionButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`
        fixed bottom-6 right-6 z-40
        bg-primary-600 hover:bg-primary-700
        text-white font-semibold
        px-6 py-4 rounded-full
        shadow-lg hover:shadow-xl
        transition-all duration-300
        flex items-center gap-3
        ${isOpen ? 'scale-95' : 'scale-100'}
        ${className}
      `}
      aria-label="Ask AI"
      {...props}
    >
      <span className="text-2xl">💬</span>
      <span className="hidden sm:inline">Ask AI</span>
    </button>
  );
}

